module.exports = ".anmalare {\n  background-color: #FDE8E7 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/IssueWeb/public/issue-web-create-public/issue-web-create-public.component.scss
// module id = ./src/app/components/IssueWeb/public/issue-web-create-public/issue-web-create-public.component.scss
// module chunks = main